import { AppTask } from 'aurelia';
import { IAppService } from '../resources/services/app-service';
export const AppClientTask = (appClient) => AppTask.creating(IAppService, (app) => {
    app.setAppClient(appClient);
});
